export default __webpack_public_path__ + "static/media/AlanAI.6618e2ca.jfif";